var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("main", { attrs: { role: "main" } }, [
    _c("div", { staticClass: "container padding-y-4xl" }, [
      _c(
        "article",
        { staticClass: "card roomy" },
        [
          _c("font-awesome-icon", {
            staticStyle: {
              "--fa-secondary-opacity": "1",
              "--fa-primary-color": "var(--fa-navy)",
              "--fa-secondary-color": "var(--fa-yellow)",
            },
            attrs: { icon: _vm.$v6.duotone.faFaceSurprise, size: "4x" },
          }),
          _vm._v(" "),
          _c("h1", { staticClass: "margin-y-2xs" }, [_vm._v("Zoinks!")]),
          _vm._v(" "),
          _c("p", { staticClass: "size-lg laptop:column-8 laptop:offset-2" }, [
            _vm._v(
              "\n        We couldn't find a category named “" +
                _vm._s(_vm.titleCase(_vm.category)) +
                "”, but we do have " +
                _vm._s(_vm.categoriesCount) +
                " other categories.\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "site-link",
            {
              staticClass: "button margin-y-lg",
              staticStyle: {
                "--link-decoration-style": "none",
                "--link-decoration-line": "none",
                "--tag-link-hover-color": "var(--fa-navy)",
              },
              attrs: { to: { name: "latest.icons.categories" } },
            },
            [
              _vm._v("\n        View All Categories\n        "),
              _c("font-awesome-icon", {
                staticClass: "margin-left-xs",
                attrs: { icon: _vm.$v6.solid.faGrid2, "fixed-width": "" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }